


















































































import { Log } from "@/services/notificacoes-apple.service";
import Modal from "@/shared/components/modal.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { Component, Mixins } from "vue-property-decorator";

import { dateTimeSeconds } from "@/shared/filters";

import ListItem from "../components/visualizar/Listitem.vue";
import UltimosRecibos from "../components/visualizar/UltimosRecibos.vue";

@Component({
  components: { Modal, ListItem, UltimosRecibos },
  filters: { dateTimeSeconds },
})
export default class Visualizar extends Mixins(GlobalMixin) {
  log: Log | null = null;
  panels = [0, 1];

  download() {
    if (this.log) {
      const blob = new Blob([this.log.notification.originalJSONResponse], {
        type: "application/json",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${this.log.logNotificacaoApple.idLogNotificacaoApple}-notificacao.json`;
      link.click();
    }
  }

  open(log: Log) {
    this.log = log;
    (this.$refs.modal as Modal).open();
  }

  close(res: boolean) {
    (this.$refs.modal as Modal).close(res);
  }
}
